import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

/* eslint-disable max-len */
const Twitter: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M14.3553 4.74113C14.3655 4.88325 14.3655 5.02541 14.3655 5.16753C14.3655 9.50253 11.066 14.4975 5.03553 14.4975C3.17766 14.4975 1.45178 13.9594 0 13.0254C0.263969 13.0558 0.51775 13.066 0.791875 13.066C2.32484 13.066 3.73603 12.5483 4.86294 11.665C3.42131 11.6345 2.21319 10.6904 1.79694 9.39088C2 9.42131 2.20303 9.44163 2.41625 9.44163C2.71066 9.44163 3.00509 9.401 3.27919 9.32997C1.77666 9.02538 0.649719 7.7056 0.649719 6.11169V6.07109C1.08625 6.31475 1.59391 6.46703 2.13194 6.48731C1.24869 5.89847 0.670031 4.89341 0.670031 3.75634C0.670031 3.14722 0.832438 2.58884 1.11672 2.10153C2.73094 4.09138 5.15734 5.39084 7.87813 5.533C7.82738 5.28934 7.79691 5.03556 7.79691 4.78175C7.79691 2.97463 9.25884 1.50256 11.0761 1.50256C12.0203 1.50256 12.873 1.8985 13.472 2.53809C14.2131 2.39597 14.9238 2.12184 15.5533 1.74622C15.3096 2.50766 14.7918 3.14725 14.1116 3.55331C14.7715 3.48228 15.4111 3.2995 15.9999 3.04572C15.5533 3.69544 14.9949 4.27409 14.3553 4.74113Z'
				fill='#1DA1F2'
			/>
		</Svg>
	);
};

export { Twitter };
